import React, { useMemo, useState } from 'react';
import { FaExclamationCircle } from 'react-icons/fa';
import { connect } from 'react-redux';
import DeviceList from '../../containers/DeviceList/DeviceList';
import Devices from '../../containers/Devices/Devices';
import DeviceSteering from '../../containers/DeviceSteering/DeviceSteering';
import JsonData from '../../containers/JsonData/JsonData';
import Box from '../../hoc/Box/Box';
import classes from './DevicesPage.css';

const DevicesPage = (props) => {
   const [currentShowDeets, setCurrentShowDeets] = useState(null);

   const updateShowDeets = (device) => {
    setCurrentShowDeets(device);
   }

  const TDCSisGroupPauseEnabled = sessionStorage.getItem('groupEnabled') === 'disabled' ? false : true;
  
  const boostedDevicesCount = useMemo(() => {
    return Object.keys(props.speedBoostDevices).length
    ? props.speedBoostDevices.count
    : 0;
  },[props?.speedBoostDevices])
    

  const steeringComponentDevices =  useMemo(() => {
    return props?.devicesByEquipment?.filter((device) => {
      if (typeof device?.steering?.forced?.freqBand === 'string') {
        return device.steering.forced.freqBand.includes('2.4G');
      }
    });
  }, [props?.devicesByEquipment])


  const boostWarningMessage = useMemo(() => {
    const deviceBoostingMsg = (boostedDevicesCount == 4) ? 'Account has reached maximum number of boosted devices. No additional devices will boost.' : undefined;
    if (deviceBoostingMsg !== undefined) {
      return (
          <Box>
            <div className={classes.warningDailog}>
              <FaExclamationCircle
                id='boostIcon'
                color={'red'}
                fontSize={'30px'}
                style={{ marginRight: '10px' }}
              />
              <span id='boostMessage' >
                {deviceBoostingMsg}
              </span>
            </div>
            <div className={classes.Spacer} />
          </Box>
      )
    }
  }, [boostedDevicesCount]);
  
  const devices = useMemo(() => {
    return (
      <Devices
        devicesByEquipment={props.devicesByEquipment}
        selectedEquipment={
          props?.equipment?.selectedEquipment
            ? props.equipment.selectedEquipment
            : null
        }
      />
    )
    
  },[props.devicesByEquipment, props?.equipment?.selectedEquipment])

  const deviceSteering = () => {
    if(props.devicesByEquipment  && 
      sessionStorage.getItem('featureFlags').includes('smartSteer'))
    
      if (props?.equipment?.selectedEquipment?.type === "pod" || props?.equipment?.selectedEquipment.type === "router") {
        return <div />
    }else {
        return (
        <>
            <Box>
            <div className={classes.Spacer} />
          <DeviceSteering
            devicesByEquipment={props.devicesByEquipment}
            updateShowDeets={updateShowDeets}
            currentShowDeets={currentShowDeets}
          />
            </Box>
            </>
      ) ;
      }
  }

  const deviceList = () => {
    return (<DeviceList
      devicesByEquipment={props.devicesByEquipment}
      radioInfo={props.radioInfo}
      realWan={props.realWan}
      enableGroupPause={TDCSisGroupPauseEnabled}
    />)
  }


  const jsonData = useMemo(() => {
    return (<JsonData devicesByEquipment={props.devicesByEquipment} />)
  },[props.devicesByEquipment])


  return (
    <Box>
      <div className={[classes.MainContent, classes[props.equipment.selectedEquipment.type + 'page']].join(' ')}>
        <div className={classes.MainContentContainer}>
          {boostWarningMessage}
          {devices}
          {deviceSteering()}
          <div className={classes.Spacer} />
          {deviceList()}
          <div className={classes.Spacer} />
          {jsonData}
          <div className={classes.Spacer} />
        </div>
      </div>
    </Box>
  )
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    isPinxt: state.auth.pToken !== null,
    loggedinUserId: sessionStorage.getItem('userId'),
    account: state.settings.account,
    realDevices: state.devices.realDevices,
    devicesByEquipment: state.devices.devicesByEquipment,
    radioInfo: state.devices.radioInfo,
    realWan: state.wan.realWan,
    equipment: state.equipment,
    speedBoostDevices: state.speedBoost.speedBoostDevices,
  };
};

export default connect(mapStateToProps)(DevicesPage);
